import { apiGetService } from './baseApi.service';

export default function contactUsSearch(businessUnit, audience) {
  return (async () => {
    const url = `/api/contactUs/getAudienceData?businessUnit=${businessUnit}&audience=${audience}`;

    return apiGetService(url);
  })();
}
